module.exports = __webpack_public_path__ + "img/index-qysl5.763af886.png";